/**
 * vue-resource v0.1.17
 * https://github.com/vuejs/vue-resource
 * Released under the MIT License.
 */

(function webpackUniversalModuleDefinition(root, factory) {
    if(typeof exports === 'object' && typeof module === 'object')
        module.exports = factory();
    else if(typeof define === 'function' && define.amd)
        define([], factory);
    else if(typeof exports === 'object')
        exports["VueResource"] = factory();
    else
        root["VueResource"] = factory();
})(this, function() {
    return /******/ (function(modules) { // webpackBootstrap
        /******/ 	// The module cache
        /******/ 	var installedModules = {};

        /******/ 	// The require function
        /******/ 	function __webpack_require__(moduleId) {

            /******/ 		// Check if module is in cache
            /******/ 		if(installedModules[moduleId])
            /******/ 			return installedModules[moduleId].exports;

            /******/ 		// Create a new module (and put it into the cache)
            /******/ 		var module = installedModules[moduleId] = {
                /******/ 			exports: {},
                /******/ 			id: moduleId,
                /******/ 			loaded: false
                /******/ 		};

            /******/ 		// Execute the module function
            /******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

            /******/ 		// Flag the module as loaded
            /******/ 		module.loaded = true;

            /******/ 		// Return the exports of the module
            /******/ 		return module.exports;
            /******/ 	}


        /******/ 	// expose the modules object (__webpack_modules__)
        /******/ 	__webpack_require__.m = modules;

        /******/ 	// expose the module cache
        /******/ 	__webpack_require__.c = installedModules;

        /******/ 	// __webpack_public_path__
        /******/ 	__webpack_require__.p = "";

        /******/ 	// Load entry module and return exports
        /******/ 	return __webpack_require__(0);
        /******/ })
        /************************************************************************/
        /******/ ([
        /* 0 */
        /***/ function(module, exports, __webpack_require__) {

            /**
             * Install plugin.
             */

            function install(Vue) {

                var _ = __webpack_require__(1)(Vue);

                Vue.url = __webpack_require__(2)(_);
                Vue.http = __webpack_require__(3)(_);
                Vue.resource = __webpack_require__(7)(_);

                Object.defineProperties(Vue.prototype, {

                    $url: {
                        get: function () {
                            return _.options(Vue.url, this, this.$options.url);
                        }
                    },

                    $http: {
                        get: function () {
                            return _.options(Vue.http, this, this.$options.http);
                        }
                    },

                    $resource: {
                        get: function () {
                            return Vue.resource.bind(this);
                        }
                    }

                });
            }

            if (window.Vue) {
                Vue.use(install);
            }

            module.exports = install;

            /***/ },
        /* 1 */
        /***/ function(module, exports) {

            /**
             * Utility functions.
             */

            module.exports = function (Vue) {

                var _ = Vue.util.extend({}, Vue.util);

                _.isString = function (value) {
                    return typeof value === 'string';
                };

                _.isFunction = function (value) {
                    return typeof value === 'function';
                };

                _.options = function (fn, obj, options) {

                    options = options || {};

                    if (_.isFunction(options)) {
                        options = options.call(obj);
                    }

                    return _.extend(fn.bind({vm: obj, options: options}), fn, {options: options});
                };

                _.each = function (obj, iterator) {

                    var i, key;

                    if (typeof obj.length == 'number') {
                        for (i = 0; i < obj.length; i++) {
                            iterator.call(obj[i], obj[i], i);
                        }
                    } else if (_.isObject(obj)) {
                        for (key in obj) {
                            if (obj.hasOwnProperty(key)) {
                                iterator.call(obj[key], obj[key], key);
                            }
                        }
                    }

                    return obj;
                };

                _.extend = function (target) {

                    var array = [], args = array.slice.call(arguments, 1), deep;

                    if (typeof target == 'boolean') {
                        deep = target;
                        target = args.shift();
                    }

                    args.forEach(function (arg) {
                        extend(target, arg, deep);
                    });

                    return target;
                };

                function extend(target, source, deep) {
                    for (var key in source) {
                        if (deep && (_.isPlainObject(source[key]) || _.isArray(source[key]))) {
                            if (_.isPlainObject(source[key]) && !_.isPlainObject(target[key])) {
                                target[key] = {};
                            }
                            if (_.isArray(source[key]) && !_.isArray(target[key])) {
                                target[key] = [];
                            }
                            extend(target[key], source[key], deep);
                        } else if (source[key] !== undefined) {
                            target[key] = source[key];
                        }
                    }
                }

                return _;
            };


            /***/ },
        /* 2 */
        /***/ function(module, exports) {

            /**
             * Service for URL templating.
             */

            var ie = document.documentMode;
            var el = document.createElement('a');

            module.exports = function (_) {

                function Url(url, params) {

                    var urlParams = {}, queryParams = {}, options = url, query;

                    if (!_.isPlainObject(options)) {
                        options = {url: url, params: params};
                    }

                    options = _.extend(true, {},
                        Url.options, this.options, options
                    );

                    url = options.url.replace(/(\/?):([a-z]\w*)/gi, function (match, slash, name) {

                        if (options.params[name]) {
                            urlParams[name] = true;
                            return slash + encodeUriSegment(options.params[name]);
                        }

                        return '';
                    });

                    if (_.isString(options.root) && !url.match(/^(https?:)?\//)) {
                        url = options.root + '/' + url;
                    }

                    _.each(options.params, function (value, key) {
                        if (!urlParams[key]) {
                            queryParams[key] = value;
                        }
                    });

                    query = Url.params(queryParams);

                    if (query) {
                        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
                    }

                    return url;
                }

                /**
                 * Url options.
                 */

                Url.options = {
                    url: '',
                    root: null,
                    params: {}
                };

                /**
                 * Encodes a Url parameter string.
                 *
                 * @param {Object} obj
                 */

                Url.params = function (obj) {

                    var params = [];

                    params.add = function (key, value) {

                        if (_.isFunction (value)) {
                            value = value();
                        }

                        if (value === null) {
                            value = '';
                        }

                        this.push(encodeUriSegment(key) + '=' + encodeUriSegment(value));
                    };

                    serialize(params, obj);

                    return params.join('&');
                };

                /**
                 * Parse a URL and return its components.
                 *
                 * @param {String} url
                 */

                Url.parse = function (url) {

                    if (ie) {
                        el.href = url;
                        url = el.href;
                    }

                    el.href = url;

                    return {
                        href: el.href,
                        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
                        port: el.port,
                        host: el.host,
                        hostname: el.hostname,
                        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
                        search: el.search ? el.search.replace(/^\?/, '') : '',
                        hash: el.hash ? el.hash.replace(/^#/, '') : ''
                    };
                };

                function serialize(params, obj, scope) {

                    var array = _.isArray(obj), plain = _.isPlainObject(obj), hash;

                    _.each(obj, function (value, key) {

                        hash = _.isObject(value) || _.isArray(value);

                        if (scope) {
                            key = scope + '[' + (plain || hash ? key : '') + ']';
                        }

                        if (!scope && array) {
                            params.add(value.name, value.value);
                        } else if (hash) {
                            serialize(params, value, key);
                        } else {
                            params.add(key, value);
                        }
                    });
                }

                function encodeUriSegment(value) {

                    return encodeUriQuery(value, true).
                        replace(/%26/gi, '&').
                        replace(/%3D/gi, '=').
                        replace(/%2B/gi, '+');
                }

                function encodeUriQuery(value, spaces) {

                    return encodeURIComponent(value).
                        replace(/%40/gi, '@').
                        replace(/%3A/gi, ':').
                        replace(/%24/g, '$').
                        replace(/%2C/gi, ',').
                        replace(/%20/g, (spaces ? '%20' : '+'));
                }

                return _.url = Url;
            };


            /***/ },
        /* 3 */
        /***/ function(module, exports, __webpack_require__) {

            /**
             * Service for sending network requests.
             */

            var xhr = __webpack_require__(4);
            var jsonp = __webpack_require__(6);
            var Promise = __webpack_require__(5);

            module.exports = function (_) {

                var originUrl = _.url.parse(location.href);
                var jsonType = {'Content-Type': 'application/json;charset=utf-8'};

                function Http(url, options) {

                    var promise;

                    if (_.isPlainObject(url)) {
                        options = url;
                        url = '';
                    }

                    options = _.extend({url: url}, options);
                    options = _.extend(true, {},
                        Http.options, this.options, options
                    );

                    if (options.crossOrigin === null) {
                        options.crossOrigin = crossOrigin(options.url);
                    }

                    options.method = options.method.toUpperCase();
                    options.headers = _.extend({}, Http.headers.common,
                        !options.crossOrigin ? Http.headers.custom : {},
                        Http.headers[options.method.toLowerCase()],
                        options.headers
                    );

                    if (_.isPlainObject(options.data) && /^(GET|JSONP)$/i.test(options.method)) {
                        _.extend(options.params, options.data);
                        delete options.data;
                    }

                    if (options.emulateHTTP && !options.crossOrigin && /^(PUT|PATCH|DELETE)$/i.test(options.method)) {
                        options.headers['X-HTTP-Method-Override'] = options.method;
                        options.method = 'POST';
                    }

                    if (options.emulateJSON && _.isPlainObject(options.data)) {
                        options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                        options.data = _.url.params(options.data);
                    }

                    if (_.isObject(options.data) && /FormData/i.test(options.data.toString())) {
                        delete options.headers['Content-Type'];
                    }

                    if (_.isPlainObject(options.data)) {
                        options.data = JSON.stringify(options.data);
                    }

                    promise = (options.method == 'JSONP' ? jsonp : xhr).call(this.vm, _, options);
                    promise = extendPromise(promise.then(transformResponse, transformResponse), this.vm);

                    if (options.success) {
                        promise = promise.success(options.success);
                    }

                    if (options.error) {
                        promise = promise.error(options.error);
                    }

                    return promise;
                }

                function extendPromise(promise, vm) {

                    promise.success = function (fn) {

                        return extendPromise(promise.then(function (response) {
                            return fn.call(vm, response.data, response.status, response) || response;
                        }), vm);

                    };

                    promise.error = function (fn) {

                        return extendPromise(promise.then(undefined, function (response) {
                            return fn.call(vm, response.data, response.status, response) || response;
                        }), vm);

                    };

                    promise.always = function (fn) {

                        var cb = function (response) {
                            return fn.call(vm, response.data, response.status, response) || response;
                        };

                        return extendPromise(promise.then(cb, cb), vm);
                    };

                    return promise;
                }

                function transformResponse(response) {

                    try {
                        response.data = JSON.parse(response.responseText);
                    } catch (e) {
                        response.data = response.responseText;
                    }

                    return response.ok ? response : Promise.reject(response);
                }

                function crossOrigin(url) {

                    var requestUrl = _.url.parse(url);

                    return (requestUrl.protocol !== originUrl.protocol || requestUrl.host !== originUrl.host);
                }

                Http.options = {
                    method: 'get',
                    params: {},
                    data: '',
                    xhr: null,
                    jsonp: 'callback',
                    beforeSend: null,
                    onComplete: null,
                    crossOrigin: null,
                    emulateHTTP: false,
                    emulateJSON: false
                };

                Http.headers = {
                    put: jsonType,
                    post: jsonType,
                    patch: jsonType,
                    delete: jsonType,
                    common: {'Accept': 'application/json, text/plain, */*'},
                    custom: {'X-Requested-With': 'XMLHttpRequest'}
                };

                ['get', 'put', 'post', 'patch', 'delete', 'jsonp'].forEach(function (method) {

                    Http[method] = function (url, data, success, options) {

                        if (_.isFunction(data)) {
                            options = success;
                            success = data;
                            data = undefined;
                        }

                        return this(url, _.extend({method: method, data: data, success: success}, options));
                    };
                });

                return _.http = Http;
            };


            /***/ },
        /* 4 */
        /***/ function(module, exports, __webpack_require__) {

            /**
             * XMLHttp request.
             */

            var Promise = __webpack_require__(5);
            var XDomain = window.XDomainRequest;

            module.exports = function (_, options) {

                var request = new XMLHttpRequest(), promise;

                if (XDomain && options.crossOrigin) {
                    request = new XDomainRequest(); options.headers = {};
                }

                if (_.isPlainObject(options.xhr)) {
                    _.extend(request, options.xhr);
                }

                if (_.isFunction(options.beforeSend)) {
                    options.beforeSend.call(this, request, options);
                }

                promise = new Promise(function (resolve, reject) {

                    request.open(options.method, _.url(options), true);

                    _.each(options.headers, function (value, header) {
                        request.setRequestHeader(header, value);
                    });

                    var handler = function (event) {

                        request.ok = event.type === 'load';

                        if (request.ok && request.status) {
                            request.ok = request.status >= 200 && request.status < 300;
                        }

                        if (_.isFunction(options.onComplete)) {
                            options.onComplete.call(this, request, options);
                        }

                        (request.ok ? resolve : reject)(request);
                    };

                    request.onload = handler;
                    request.onabort = handler;
                    request.onerror = handler;

                    request.send(options.data);
                });

                return promise;
            };


            /***/ },
        /* 5 */
        /***/ function(module, exports) {

            /**
             * Promises/A+ polyfill v1.1.0 (https://github.com/bramstein/promis)
             */

            var RESOLVED = 0;
            var REJECTED = 1;
            var PENDING  = 2;

            function Promise(executor) {

                this.state = PENDING;
                this.value = undefined;
                this.deferred = [];

                var promise = this;

                try {
                    executor(function (x) {
                        promise.resolve(x);
                    }, function (r) {
                        promise.reject(r);
                    });
                } catch (e) {
                    promise.reject(e);
                }
            }

            Promise.reject = function (r) {
                return new Promise(function (resolve, reject) {
                    reject(r);
                });
            };

            Promise.resolve = function (x) {
                return new Promise(function (resolve, reject) {
                    resolve(x);
                });
            };

            Promise.all = function all(iterable) {
                return new Promise(function (resolve, reject) {
                    var count = 0,
                        result = [];

                    if (iterable.length === 0) {
                        resolve(result);
                    }

                    function resolver(i) {
                        return function (x) {
                            result[i] = x;
                            count += 1;

                            if (count === iterable.length) {
                                resolve(result);
                            }
                        };
                    }

                    for (var i = 0; i < iterable.length; i += 1) {
                        iterable[i].then(resolver(i), reject);
                    }
                });
            };

            Promise.race = function race(iterable) {
                return new Promise(function (resolve, reject) {
                    for (var i = 0; i < iterable.length; i += 1) {
                        iterable[i].then(resolve, reject);
                    }
                });
            };

            var p = Promise.prototype;

            p.resolve = function resolve(x) {
                var promise = this;

                if (promise.state === PENDING) {
                    if (x === promise) {
                        throw new TypeError('Promise settled with itself.');
                    }

                    var called = false;

                    try {
                        var then = x && x['then'];

                        if (x !== null && typeof x === 'object' && typeof then === 'function') {
                            then.call(x, function (x) {
                                if (!called) {
                                    promise.resolve(x);
                                }
                                called = true;

                            }, function (r) {
                                if (!called) {
                                    promise.reject(r);
                                }
                                called = true;
                            });
                            return;
                        }
                    } catch (e) {
                        if (!called) {
                            promise.reject(e);
                        }
                        return;
                    }
                    promise.state = RESOLVED;
                    promise.value = x;
                    promise.notify();
                }
            };

            p.reject = function reject(reason) {
                var promise = this;

                if (promise.state === PENDING) {
                    if (reason === promise) {
                        throw new TypeError('Promise settled with itself.');
                    }

                    promise.state = REJECTED;
                    promise.value = reason;
                    promise.notify();
                }
            };

            p.notify = function notify() {
                var promise = this;

                async(function () {
                    if (promise.state !== PENDING) {
                        while (promise.deferred.length) {
                            var deferred = promise.deferred.shift(),
                                onResolved = deferred[0],
                                onRejected = deferred[1],
                                resolve = deferred[2],
                                reject = deferred[3];

                            try {
                                if (promise.state === RESOLVED) {
                                    if (typeof onResolved === 'function') {
                                        resolve(onResolved.call(undefined, promise.value));
                                    } else {
                                        resolve(promise.value);
                                    }
                                } else if (promise.state === REJECTED) {
                                    if (typeof onRejected === 'function') {
                                        resolve(onRejected.call(undefined, promise.value));
                                    } else {
                                        reject(promise.value);
                                    }
                                }
                            } catch (e) {
                                reject(e);
                            }
                        }
                    }
                });
            };

            p.catch = function (onRejected) {
                return this.then(undefined, onRejected);
            };

            p.then = function then(onResolved, onRejected) {
                var promise = this;

                return new Promise(function (resolve, reject) {
                    promise.deferred.push([onResolved, onRejected, resolve, reject]);
                    promise.notify();
                });
            };

            var queue = [];
            var async = function (callback) {
                queue.push(callback);

                if (queue.length === 1) {
                    async.async();
                }
            };

            async.run = function () {
                while (queue.length) {
                    queue[0]();
                    queue.shift();
                }
            };

            if (window.MutationObserver) {
                var el = document.createElement('div');
                var mo = new MutationObserver(async.run);

                mo.observe(el, {
                    attributes: true
                });

                async.async = function () {
                    el.setAttribute("x", 0);
                };
            } else {
                async.async = function () {
                    setTimeout(async.run);
                };
            }

            module.exports = window.Promise || Promise;


            /***/ },
        /* 6 */
        /***/ function(module, exports, __webpack_require__) {

            /**
             * JSONP request.
             */

            var Promise = __webpack_require__(5);

            module.exports = function (_, options) {

                var callback = '_jsonp' + Math.random().toString(36).substr(2), response = {}, script, body;

                options.params[options.jsonp] = callback;

                if (_.isFunction(options.beforeSend)) {
                    options.beforeSend.call(this, {}, options);
                }

                return new Promise(function (resolve, reject) {

                    script = document.createElement('script');
                    script.src = _.url(options);
                    script.type = 'text/javascript';
                    script.async = true;

                    window[callback] = function (data) {
                        body = data;
                    };

                    var handler = function (event) {

                        delete window[callback];
                        document.body.removeChild(script);

                        if (event.type === 'load' && !body) {
                            event.type = 'error';
                        }

                        response.ok = event.type !== 'error';
                        response.status = response.ok ? 200 : 404;
                        response.responseText = body ? body : event.type;

                        if (_.isFunction(options.onComplete)) {
                            options.onComplete.call(this, response, options);
                        }

                        (response.ok ? resolve : reject)(response);
                    };

                    script.onload = handler;
                    script.onerror = handler;

                    document.body.appendChild(script);
                });

            };


            /***/ },
        /* 7 */
        /***/ function(module, exports) {

            /**
             * Service for interacting with RESTful services.
             */

            module.exports = function (_) {

                function Resource(url, params, actions, options) {

                    var self = this, resource = {};

                    actions = _.extend({},
                        Resource.actions,
                        actions
                    );

                    _.each(actions, function (action, name) {

                        action = _.extend(true, {url: url, params: params || {}}, options, action);

                        resource[name] = function () {
                            return (self.$http || _.http)(opts(action, arguments));
                        };
                    });

                    return resource;
                }

                function opts(action, args) {

                    var options = _.extend({}, action), params = {}, data, success, error;

                    switch (args.length) {

                        case 4:

                            error = args[3];
                            success = args[2];

                        case 3:
                        case 2:

                            if (_.isFunction(args[1])) {

                                if (_.isFunction(args[0])) {

                                    success = args[0];
                                    error = args[1];

                                    break;
                                }

                                success = args[1];
                                error = args[2];

                            } else {

                                params = args[0];
                                data = args[1];
                                success = args[2];

                                break;
                            }

                        case 1:

                            if (_.isFunction(args[0])) {
                                success = args[0];
                            } else if (/^(POST|PUT|PATCH)$/i.test(options.method)) {
                                data = args[0];
                            } else {
                                params = args[0];
                            }

                            break;

                        case 0:

                            break;

                        default:

                            throw 'Expected up to 4 arguments [params, data, success, error], got ' + args.length + ' arguments';
                    }

                    options.data = data;
                    options.params = _.extend({}, options.params, params);

                    if (success) {
                        options.success = success;
                    }

                    if (error) {
                        options.error = error;
                    }

                    return options;
                }

                Resource.actions = {

                    get: {method: 'GET'},
                    save: {method: 'POST'},
                    query: {method: 'GET'},
                    update: {method: 'PUT'},
                    remove: {method: 'DELETE'},
                    delete: {method: 'DELETE'}

                };

                return _.resource = Resource;
            };


            /***/ }
        /******/ ])
});